import { Fraction } from 'bi-fraction';
import { getDexGraphqlEndpoint } from '../endpoints/h2GraphEndpoints';
import { server } from '../server';
import { getAgent } from './agents';
export const getAgentFunTokenPrice = async (chainLayer, agentfunTokenAddress) => {
    // eslint-disable-next-line prefer-const
    let [response, tokenDayDatas] = await Promise.all([
        server.get({ endpoint: 'latest-price/agentfun', chainLayer }),
        fetchTokenDayData(agentfunTokenAddress.toLowerCase(), chainLayer),
    ]);
    if (!response.ok) {
        throw new Error(`Error fetching Agent FUN token price: ${response.statusText}`);
    }
    if (tokenDayDatas.length < 2) {
        // maybe token is new in pool, return 0 for 24h change
        tokenDayDatas = [{ priceUSD: '1' }, { priceUSD: '1' }];
    }
    const price = await response.json();
    const latestPrice = parseFloat(tokenDayDatas[0].priceUSD);
    const previousPrice = parseFloat(tokenDayDatas[1].priceUSD);
    const priceChange24h = new Fraction((latestPrice - previousPrice) / previousPrice);
    return {
        usd_price: new Fraction(price),
        usd_price_change_24h: priceChange24h,
    };
};
/**
 * @param currency - default is "usd"
 */
export const getBondingTokenPrice = async (chainLayer, bondingAddress, currency = 'usd') => {
    const queryParams = new URLSearchParams({ token: bondingAddress, currency });
    const [response, agent] = await Promise.all([
        server.get({
            endpoint: 'latest-price',
            chainLayer,
            queryParams,
        }),
        getAgent(chainLayer, bondingAddress),
    ]);
    if (!response.ok) {
        throw new Error(`Error fetching bonding token price: ${response.statusText}`);
    }
    const price = await response.json();
    return {
        usd_price: new Fraction(price),
        usd_price_change_24h: new Fraction(agent.price_change24h ?? 0),
    };
};
async function fetchTokenDayData(tokenAddress, chainLayer) {
    const graphqlResponse = await fetch(getDexGraphqlEndpoint(chainLayer), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            query: `
        {
          tokenDayDatas(
            first: 2,
            where: {token: "${tokenAddress}"},
            orderBy: date
            orderDirection: desc
          ) {
            date
            priceUSD
          }
        }
      `,
        }),
    });
    if (!graphqlResponse.ok) {
        throw new Error(`Error fetching token day data: ${graphqlResponse.statusText}`);
    }
    const graphqlData = await graphqlResponse.json();
    return graphqlData.data.tokenDayDatas;
}
